import * as React from 'react';

import { Link } from 'libs/router';

import FacebookButton from 'components/external-integration/facebook/button/FacebookButton';

import { __t, applyTranslations } from 'utils/language';

import './connect-your-instagram-channel.scss';

applyTranslations(require('./connect-your-instagram-channel.i18n.json'));

interface Props {
  onSuccessfulLogin: () => void,
  onLogout: () => void
}

const ConnectYourInstagramChannel = ({ onSuccessfulLogin, onLogout }: Props): JSX.Element => (
  <div className="connect-your-instagram-channel">
    <div className="connect-your-instagram-channel__container">
      <div className="connect-your-instagram-channel__body">
        <div className="connect-your-instagram-channel__header">
          {__t('connect_your_instagram_channel.header')}
        </div>
        <div className="connect-your-instagram-channel__subheader">
          {__t('connect_your_instagram_channel.subheader')}
        </div>
        <div className="connect-your-instagram-channel__text">
          <span>
            {__t('connect_your_instagram_channel.text')}
          </span>
          <ul className="connect-your-instagram-channel__list">
            <li
              dangerouslySetInnerHTML={{ __html: __t('connect_your_instagram_channel.line1') }}
            />
            <li
              dangerouslySetInnerHTML={{ __html: __t('connect_your_instagram_channel.line2') }}
            />
            <li
              dangerouslySetInnerHTML={{ __html: __t('connect_your_instagram_channel.line3') }}
            />
          </ul>
        </div>
      </div>
      <div className="connect-your-instagram-channel__buttons">
        <FacebookButton
          size="small"
          onSuccessfulLogin={onSuccessfulLogin}
          onLogout={onLogout}
        />
        <Link
          target="_blank"
          rel="noopener noreferrer"
          to="https://help.collabary.com/en/articles/6380279-why-should-i-connect-my-instagram-account-to-collabary"
          className="connect-your-instagram-channel__link"
        >
          {__t('connect_your_instagram_channel.link')}
        </Link>
      </div>
      <div className="connect-your-instagram-channel__image" />
    </div>
  </div>
);

export default ConnectYourInstagramChannel;
